import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PageNav, PageRoutes, Text } from '@eltoro-ui/components';
import { Layout, Loading } from 'Components';
import { useSelector } from 'react-redux';
import { TabWrapper } from 'Pages/MyProfile/components/TabWrapper';
import { TRootState } from 'types';
import { RecommendationTypeEnum } from 'enums';
import RecommendedForYou from './components/RecommendedForYou';
import Library from './components/Library';
import './styles.scss';

export const RecommendationsPage = () => {
  const [alertPages, setAlertPages] = useState<any>([]);
  const { userData } = useSelector((state: TRootState) => state.userReducer);
  const { userRecommendations } = useSelector((state: TRootState) => state.recommendationsReducer);

  const contactsData = userRecommendations?.recommendations.filter(
    (recommendation: any) => recommendation.recommendation_type === RecommendationTypeEnum.AGENT
  );
  const contactFile = userRecommendations?.contact_files;
  const buyersCount = contactsData?.find((rec: any) => rec.sub_type === 'buyer')?.buyer_count ?? 0;
  const sellersCount =
    contactsData?.find((rec: any) => rec.sub_type === 'seller')?.seller_count ?? 0;

  const isAnalyzing =
    contactFile?.active >= 1 &&
    contactsData?.find((rec: any) => rec.sub_type === 'seller')?.seller_count === null &&
    contactsData?.find((rec: any) => rec.sub_type === 'buyer')?.buyer_count === null;

  const isImporting = contactFile?.pending >= 1 && contactFile?.active === 0;
  const isEmpty = contactFile?.active === 0 && buyersCount === 0 && sellersCount === 0;
  const hasOnlyBuyer = buyersCount >= 0 && sellersCount === null;
  const hasOnlySeller = sellersCount >= 0 && buyersCount === null;

  useEffect(() => {
    setAlertPages([
      {
        path: '/activity-alerts',
        title: 'Recommended for You',
        exactPath: true,
        component: () => (
          <TabWrapper>
            {!userRecommendations ? (
              <Loading />
            ) : (
              <RecommendedForYou
                recommendations={userRecommendations?.recommendations}
                audiences={userRecommendations?.audiences}
                campaigns={userRecommendations?.campaigns}
                currentPage={userRecommendations.current_page}
                totalCount={userRecommendations.total_count}
                totalPages={userRecommendations.total_pages}
              />
            )}
          </TabWrapper>
        ),
      },
      {
        path: '/activity-alerts/library',
        title: 'Library',
        exactPath: false,
        component: () => (
          <TabWrapper>
            {!userRecommendations ? (
              <Loading />
            ) : (
              <Library
                buyersCount={buyersCount}
                sellersCount={sellersCount}
                isAnalizing={isAnalyzing}
                isImporting={isImporting}
                isEmpty={isEmpty}
                hasOnlyBuyer={hasOnlyBuyer}
                hasOnlySeller={hasOnlySeller}
                recommendations={contactsData}
              />
            )}
          </TabWrapper>
        ),
      },
    ]);
  }, [userRecommendations]);

  return (
    <Layout>
      <div className="RecommendationContainer">
        <BrowserRouter>
          <nav className="RecommendationContainer__nav">
            <Text on="white" weight="bold" UNSAFE_className="title">
              Activity Alerts
            </Text>
            <Text on="white" UNSAFE_className="heading_desc">
              Beewo&#39;s Activity Alerts scan market trends that are relevant to you. Execute
              engagement on the go.
            </Text>
            <PageNav pages={alertPages} userData={userData} />
          </nav>

          <main className="RecommendationContainer__main">
            <PageRoutes pages={alertPages} />
          </main>
        </BrowserRouter>
      </div>
    </Layout>
  );
};
